import React, { useState, useEffect, useContext } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Tooltip,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid, esES, GridActionsCellItem } from "@mui/x-data-grid";
import { RootStoreContext } from "../../app/store/root";
import { toJS } from "mobx";

const GuiasRastreo = () => {
  const rootStore = useContext(RootStoreContext);
  const { entity } = rootStore.shipmentStore;

  /* UseStates */
  const [pageSize, setPageSize] = useState(5);
  const [detalles, setDetalles] = useState([]);
  /* End UseState */

  useEffect(() => {
    if (entity) {
      setDetalles(entity?.detalles ? [...entity?.detalles] : []);
    }
  }, [entity]);

  const columns = [
    {
      field: "numeroRemisionFactura",
      headerName: "No. de remisión de factura",
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">No. de remisión de factura</span>
      ),
    },
    {
      field: "numeroOrdenCompra",
      headerName: "No. de orden de compra",
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">No. de orden de compra</span>
      ),
    },
    {
      field: "posicionOrdenCompra",
      headerName: "Posición de orden de compra",
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Posición de orden de compra</span>
      ),
    },
    {
      field: "cantidadBultos",
      headerName: "Cantidad de bultos",
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Cantidad de bultos</span>
      ),
    },
    {
      field: "cantidadMercancia",
      headerName: "Cantidad de mercancía",
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">Cantidad de mercancía</span>
      ),
    },
  ];
  return (
    <Box>
      <Accordion elevation={1}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="guias-content"
          id="guias-header"
        >
          <Typography variant="h6" color={"primary.main"}>
            Información de la guía
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              width: "100%",
              "& .tableHeaders": {
                color: "primary.main",
              },
            }}
          >
            <DataGrid
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              autoHeight
              rows={detalles}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              getRowId={(row) => row.idPartidaGuia}
              rowsPerPageOptions={[5, 10, 20]}
              pagination
            />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default observer(GuiasRastreo);
